module.exports = require("module");


//////////////////
// WEBPACK FOOTER
// external "module"
// module id = 73
// module chunks = 0